import { IExtensionManagementForm } from "../models/models";
import * as yup from "yup";
import dayjs from "dayjs";

export const WEEK_DAYS_IND = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const EXTENSION_MANAGEMENT_INITIAL_VALUE_FORM: IExtensionManagementForm = {
        raNumber: '',
        dmsIdentificationCode: null,
        pickUpDate: null,
        renewalsAndSubstitutions: '',
        pickupLocation: null,
        expectedDropoffDate: null,
        expectedDropoffLocation: null,
        requestedDropoffDateTimeList: [],
        requestedDropoffDateTime: null,
        requestedDropoffDateTimeErrorStatus: false,
        billingOwner: null,
        extensionPeriod: '',
        renewedByExtension: null,
        lastModifiedBy: '',
        extensionTimestamp: null,
        creditType: '',
        reservedPricing: false,
        rentalExtensionAmount: '',
        ancillariesExtensionAmount: '',
        totalExtensionAmount: ''
}

export const EXTENSION_MANAGEMENT_FORM_VALIDATION_SCHEMA = yup.object().shape({
        requestedDropoffDateTime: yup.date()
            .nullable()
            .typeError('common.error.invalidDate')
            .test({
                name: 'minValue',
                message: "common.error.invalidDate",
                test(value, context) {
                    let minDropoffDate = null; // min accepted dropoffdate
                    if (context.parent.requestedDropoffDateTimeList.length > 0) {
                        minDropoffDate = context.parent.requestedDropoffDateTimeList[context.parent.requestedDropoffDateTimeList.length -1];
                    } else if (!!context.parent.expectedDropoffDate) {
                        minDropoffDate = context.parent.expectedDropoffDate;
                    }

                    const now = dayjs().add(1, 'minutes');
                    if (minDropoffDate?.isBefore(now)) {
                        minDropoffDate =  now;
                    }

                    const requestedDate = dayjs(value);
                    if (requestedDate.isAfter(minDropoffDate)) {
                        return true;
                    }

                    return false;
                }
            })
            .test({
                name: 'invalidTime',
                message: "common.error.invalidTime",
                test(value, context) {
                    return !context.parent.requestedDropoffDateTimeErrorStatus;
                }
            })
            .required('common.error.required'),
        billingOwner: yup.object()
            .nullable()
            .required("common.error.required")
})